import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from  '@gtpl/shared-utils/error-messages';
import { WorkstationsController } from './workstations.controller';
import { WorkStations } from './workstations.entity';
import { WorkstationsService } from './workstations.service';
import { WorkStationsRepository } from './repository/workstation-repository';
import { WorkstationAdapter } from './dto/workstation.adapter';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    TypeOrmModule.forFeature([WorkStationsRepository]),
  ],
  controllers: [WorkstationsController],
  providers: [WorkstationsService, WorkstationAdapter ,ApplicationExceptionHandler,LogsService],
  exports:[WorkstationsService]
})
export class WorkstationsModule {}
